import React from 'react';
import { connect } from 'react-redux';
import { find, isEqual, map , get} from 'lodash';
import store from '../../../helpers/store';

import ReactTable from "react-table";
import config from '../../../config/config';
import userConfig from '../../../config/userConfig';
import ReactSelect from '../../common/ReactSelect';
import CSV from '../../../helpers/CSVExport';
import cellHeaderHOC from '../Datagrid/CellHeaderHOC';
import { splitByThousands } from '../../../helpers/NumberFormatter';
import { summaryFooter, diffFooter } from '../Datagrid/Footers';
import Box from '../Box';
import ExportModal from '../ExportModal';

import TerritoryStatsMap from './Territory/Map';
import LineChart from '../../widgets/charts/types/LineChart';
import StackedBarChart from '../../widgets/charts/types/StackedBarChart';
import DoughnutChart from '../../widgets/charts/types/DoughnutChart';
import ConfirmClick from '../ConfirmClick';
import { statsActions } from '../../../data/actions/stats';
import { territorySettings } from './Territory/Settings'; 

var worldSvg = require('!svg-inline-loader!../../../../public/img/world.svg');
var lineSvg = require('!svg-inline-loader!../../../../public/img/line.svg');
var barSvg = require('!svg-inline-loader!../../../../public/img/chart-bar.svg');
var tableSvg = require('!svg-inline-loader!../../../../public/img/table.svg');
var downloadSvg = require('!svg-inline-loader!../../../../public/img/download.svg');
import VendorLogo from "../VendorLogo";
import { dspLogos } from "../../common/Stats/utils";
const CellHeaderTable = cellHeaderHOC(ReactTable);

const toolbarChartViewIcons = {
    table: tableSvg,
    line: lineSvg,
    bar: barSvg,
}


class TerritoryStats extends React.Component {
    
    options = [
         {label: 'Top Total Income', field: 'curr_total_income', dir: 'DESC'},
         {label: 'Top Total Quantity', field: 'curr_total_quantity', dir: 'DESC'},
         {label: 'Top Physical Income', field: 'curr_physical_income', dir: 'DESC'},
         {label: 'Top Physical Quantity', field: 'curr_physical_quantity', dir: 'DESC'},
         {label: 'Top Digital Income', field: 'curr_digital_income', dir: 'DESC'},
         {label: 'Top Digital Quantity', field: 'curr_digital_quantity', dir: 'DESC'},
         {label: 'Top NR Income', field: 'curr_nr_income', dir: 'DESC'},
         {label: 'Top NR Quantity', field: 'curr_nr_quantity', dir: 'DESC'},
         {label: 'Top Income Change', field: 'total_income_diff', dir: 'DESC', prevPeriodOnly: true},
         {label: 'Top Quantity Change', field: 'total_quantity_diff', dir: 'DESC', prevPeriodOnly: true},

         {label: 'Largest % Increase', field: 'total_income_change', dir: 'DESC', prevPeriodOnly: true},
         {label: 'Largest % Decrease', field: 'total_income_change', dir: 'ASC', prevPeriodOnly: true},       
         {label: 'Bottom Total Income', field: 'curr_total_income', dir: 'ASC'},
         {label: 'Bottom Total Quantity', field: 'curr_total_quantity', dir: 'ASC'},
         {label: 'Bottom Physical Income', field: 'curr_physical_income', dir: 'ASC'},
         {label: 'Bottom Physical Quantity', field: 'curr_physical_quantity', dir: 'ASC'},
         {label: 'Bottom Digital Income', field: 'curr_digital_income', dir: 'ASC'},
         {label: 'Bottom Digital Quantity', field: 'curr_digital_quantity', dir: 'ASC'},
         {label: 'Bottom NR Income', field: 'curr_nr_income', dir: 'ASC'},
         {label: 'Bottom NR Quantity', field: 'curr_nr_quantity', dir: 'ASC'},
         {label: 'Bottom Income Change', field: 'total_income_diff', dir: 'ASC', prevPeriodOnly: true},
           {label: 'Bottom Quantity Change', field: 'total_quantity_diff', dir: 'ASC', prevPeriodOnly: true},

         
   ];

    limits = [10, 25, 50];
    
    constructor(props) {
        super(props);
        
        const territoryLimit = store.get('territoryLimit') || this.limits[0];
        
        this.state = {
          mode: "table",
          sort: this.options[0],
          limit: territoryLimit,
          logoDataFiltered: [],
          page: 0
        };
        this.setChartMode = this.setChartMode.bind(this);
        this.setSort = this.setSort.bind(this);
        this.exportToCsv = this.exportToCsv.bind(this);
        this.exportAllToCsv = this.exportAllToCsv.bind(this);
        this.setLimit = this.setLimit.bind(this);
        this.setPage = this.setPage.bind(this);
        this.getTimeseries = this.getTimeseries.bind(this);
        this.tableScrollTop = 0;
    };    
    
    setChartMode(mode){
        this.setState({mode});
        if(mode == 'line' || mode == 'bar')
            this.getTimeseries();
    }

    renderToolbar(mode, loading, limit){
       const { filter } = this.props;
        let toolbar = [];
        let modes = {
            'table': 'table',
            'line': 'chart-line',
            'bar': 'chart-bar',
        };

         let sortOptions = this.options;
         if(!(get(filter, 'global.previousPeriodSet', false)))
            sortOptions = sortOptions.filter(o=>!o.prevPeriodOnly);

        
        const limitOptions = this.limits.map(limit => ({
            label: limit == 500 ? 'All' : limit,
            value: limit        
        })),
        limitValue = find(limitOptions, {value: this.state.limit});        
        
        toolbar.push(<div key="wrapper" className="ibox-action-holder">
        <div className="ibox-actions">
        Limit: <ReactSelect value={limitValue} options={limitOptions} onChange={this.setLimit} className="single-select select-limit"/> 
          <ReactSelect value={this.state.sort} options={sortOptions} onChange={this.setSort} className="single-select"/>

          {mode == 'table' && <ExportModal exportToCsv={this.exportToCsv}  exportAllToCsv={this.exportAllToCsv} loading={loading} limit={limitValue} />}
          {(mode == 'line' || mode == 'bar') && <a key="download" title="Export" onClick={this.exportToCsvTimeseries} className="chart-icon download-link" dangerouslySetInnerHTML={{__html: downloadSvg}} />}
        </div>
        </div>)
        for (let mode in modes) {                   
            toolbar.push(<a key={mode} className={`chart-icon ibox-link ${this.state.mode == mode ? 'active' : ''}`} onClick={()=>this.setChartMode(mode)} dangerouslySetInnerHTML={{__html: toolbarChartViewIcons[mode]}}></a>);
        }

        return toolbar;
    }
    
    exportToCsv(full = false){
      const getData = full ? this.props.dispatch(statsActions.getTerritoryStats(this.props.entity, this.props.ids, this.state.sort, userConfig().fullCSVThreshold, this.state.page, this.props.continent, this.props.dateStart, this.props.dateEnd, this.props.prevDateStart, this.props.prevDateEnd, this.props.countries, this.props.imprint, this.props.vendor, this.props.transactionType)) : Promise.resolve(this.props.stats.territory);
     getData.then(()=>{
         const filename = CSV.CSVHeader('details_territories', this.state.sort.field, this.props.filter.global, this.props.parentEntityTitle); 
         return CSV.CSVExport(this.props.stats.territory.table, {filename}, 'territories');            
     })
              
    }
    
    exportAllToCsv() {
       console.log(this.props.parentEntityTitle);
         return this.props.dispatch(statsActions.getAllTerritoryStats(this.props.entity, this.props.ids, this.state.sort, userConfig().fullCSVThreshold, this.state.page, this.props.continent, this.props.dateStart, this.props.dateEnd, this.props.prevDateStart, this.props.prevDateEnd, this.props.countries, this.props.imprint, this.props.vendor, this.props.transactionType, this.props.parentEntityTitle))
    }
    
    exportToCsvTimeseries = () => {
       const data = this.props.stats.territoryTimeseries;
        let table=[];
        for(let row of data.datasets) {
            let tableRow = {code: row.id, name: row.label};
            for(let labelIndex in data.labels) {
                tableRow[data.labels[labelIndex]] = row.data[labelIndex];
            }
            table.push(tableRow);
        }
        const filename = CSV.CSVHeader('territories_timeseries', this.state.sort.field, this.props.filter.global, this.props.parentEntityTitle);
        return CSV.CSVExport(table, {filename});
     }

    setSort(sort){
        this.setState({sort}, ()=>{
            this.props.dispatch(statsActions.getTerritoryStats(this.props.entity, this.props.ids, this.state.sort, this.state.limit, this.state.page, this.props.continent, this.props.dateStart, this.props.dateEnd, this.props.prevDateStart, this.props.prevDateEnd, this.props.countries, this.props.imprint, this.props.vendor, this.props.transactionType))
        })
    }

    setLimit(limit){
      const { mode } = this.state;
      this.setState({limit: limit.value, page: 0}, ()=>{
         store.set('territoryLimit', limit.value);
         this.props.dispatch(statsActions.getTerritoryStats(this.props.entity, this.props.ids, this.state.sort, this.state.limit, this.state.page, this.props.continent, this.props.dateStart, this.props.dateEnd, this.props.prevDateStart, this.props.prevDateEnd, this.props.countries, this.props.imprint, this.props.vendor, this.props.transactionType)).then(()=>{
            if(mode == 'line' || mode == 'bar')
               this.getTimeseries();
         })
      })
   }
    
    setPage(page){
        this.setState({page}, ()=>{
            this.props.dispatch(statsActions.getTerritoryStats(this.props.entity, this.props.ids, this.state.sort, this.state.limit, this.state.page, this.props.continent, this.props.dateStart, this.props.dateEnd, this.props.prevDateStart, this.props.prevDateEnd, this.props.countries, this.props.imprint, this.props.vendor, this.props.transactionType))
        })
    }
    

    componentDidMount() {
        const { chartType } = this.props;
        this.props.dispatch(statsActions.getTerritoryStats(this.props.entity, this.props.ids, this.state.sort, this.state.limit, this.state.page, this.props.continent, this.props.dateStart, this.props.dateEnd, this.props.prevDateStart, this.props.prevDateEnd, this.props.countries, this.props.imprint, this.props.vendor, this.props.transactionType))

        if (this.props.filter.global) {
          if (this.props.filter.global !== undefined) {
            this.setState({
              logoDataFiltered: chartType
                ? dspLogos[chartType].data.filter((l) =>
                    this.props.filter.global.vendors.includes(l)
                  )
                : [],
            });
          }
        }
    }
    
    getTimeseries() {
       const { ids: id = 0 } = this.props;
      const territoryData = get(this.props.stats, `territories.${id}`, {});
        const ids = territoryData.data ? map(territoryData.data.table, 'code') : [];
        this.props.dispatch(statsActions.getTerritoryTimeseries(this.props.entity, this.props.ids, ids, this.state.sort, this.state.limit, this.state.page, this.props.continent, this.props.dateStart, this.props.dateEnd, this.props.prevDateStart, this.props.prevDateEnd, this.props.countries, this.props.imprint, this.props.vendor, this.props.transactionType))
    }
     
    componentWillReceiveProps(nextProps){
        const globalFilter = nextProps.filter.global;
        const { chartType } = this.props;
        if(nextProps.filter && globalFilter){
            if(this.props.filter.global!==undefined && !isEqual(globalFilter, this.props.filter.global)) {
               const wasPeriodSet = get(this.props, 'filter.global.previousPeriodSet', false);
                const isPeriodSet = get(nextProps, 'filter.global.previousPeriodSet', false);
                let sort = this.state.sort;
                if(wasPeriodSet && !isPeriodSet) {
                    if(sort.field == 'total_income_change')
                        sort=this.options[0];
                }
                this.setState({
                    sort
                }, ()=>{

               
                  this.props.dispatch(statsActions.getTerritoryStats(this.props.entity, this.props.ids, this.state.sort, this.state.limit, this.state.page, this.props.continent, this.props.dateStart, this.props.dateEnd, this.props.prevDateStart, this.props.prevDateEnd, this.props.countries, this.props.imprint, this.props.vendor, this.props.transactionType))
                  .then(territories => {
                        const { mode } = this.state;
                        if(mode != 'table')
                           this.getTimeseries();
                  })
               });
               
               /*
                  this.setState((prevState) => {
                     return {
                     ...prevState,
                     logoDataFiltered: chartType
                        ? dspLogos[chartType].data.filter((l) =>
                           globalFilter.vendors.includes(l)
                           )
                        : [],
                     };
                  });
               */
            }                
        }
        if(nextProps.stats.forceLoadAllTerritoriesData && !this.props.stats.forceLoadAllTerritoriesData) {
            console.log('loading export data for territories');
            this.props.dispatch(statsActions.getTerritoryStats(this.props.entity, this.props.ids, this.state.sort, userConfig().fullCSVThreshold, 0, this.props.continent, this.props.dateStart, this.props.dateEnd, this.props.prevDateStart, this.props.prevDateEnd, this.props.countries, this.props.imprint, this.props.vendor, this.props.transactionType));
        }
        
    }

    renderVendorLogos() {
        const { chartType } = this.props;
        const logoData = chartType ? this.state.logoDataFiltered : [];

        return <div className="title-vendors-list">
            {chartType && logoData && logoData.map((l) => (
                <VendorLogo key={l} name={l} />
            ))}
        </div>
    }

    render (){
        const { expanded = false, showChart = true, ids: id = 0 } = this.props;
        const { limit } = this.state;
        const title = <React.Fragment>Territories <br/><div className="small-description">This section is independent from the Main Filter Limit in order to give you an accurate territory market share no matter how many results you’re looking at. By default you can see the top 10 but you can toggle this in the Limit drop down menu on the right. You can still select a specific Vendor in the Main Filter.</div></React.Fragment>;
        const territoryData = get(this.props.stats, `territories.${id}`, {});
        const timeseriesData = get(this.props.stats, `territoriesTimeseries.${id}`, {});
        
        const totals = territoryData.totals;
        const totalRows = totals ? totals.total_rows : limit;
        let columns = territorySettings.settingsForTable(expanded?'expanded':'details', this.props.prevPeriod);
        for(let column of columns) {
            column.Footer = (props) => {
                const {id} = column;
                const [key, metric] = id.split('_');
                let value = totals[key];
                if(metric == 'income')
                   value = summaryFooter(totals, key, true);
                else if(metric == 'change')
                   value = diffFooter(totals, key);
                else if(key == 'name')
                    value = 'Total';
                return <span>{value}</span>
            };
        }
        console.log(timeseriesData);
        let tableData = get(territoryData, 'data.table', null);
        if(tableData && tableData.length)
            tableData = tableData.slice(0, limit);

        const fullWidthClassname = this.state.mode == 'line'  || this.state.mode == 'bar'|| !showChart ? 'box-table-full-width' : "";

        return <div className="table-with-chart-holder table-header-with-description">
            <Box title={title} toolbar={this.renderToolbar(this.state.mode, territoryData.loading)} vendorLogoList={this.renderVendorLogos()} spinnerEnabled={territoryData.loading || timeseriesData.loading} className={`ibox-container box-table ${fullWidthClassname}`}>
                {territoryData.data && <div>
                    {(this.state.mode=='line' && !timeseriesData.loading) &&  <div className="territory-chart"><LineChart data={timeseriesData.data} label="streams" /></div> }
                    {(this.state.mode=='bar' && !timeseriesData.loading) &&  <div className="territory-chart"><StackedBarChart data={timeseriesData.data} label="streams" /></div> }
                    {this.state.mode=='table' && <div className="territory-table territory-table--single custom-scroll">
                        <CellHeaderTable
                            className={`${this.props.prevPeriod ? "with-prev-period" : ""} territory-table-holder playlist-table`}
                            data={tableData}
                            columns={columns}
                            defaultPageSize={Math.min(totalRows, limit)}
                            minRows={1}
                            sortable={false}
                            manual
                            page={this.state.page}
                            pages={Math.ceil(totalRows / limit)}
                            onPageChange={this.setPage}
                            showPagination={totalRows > limit}
                            showPageSizeOptions={false}
                        />
                    </div>}
                </div>}
            </Box>
            {(this.state.mode=='table' && showChart) && <div className="table-chart-holder">
                <div className="table-chart-holder-inner"> 
                    <div className="chart-title">Territories</div>
                    {territoryData.data && <DoughnutChart data={territoryData.data.chart} chartID="top_territories_pie_chart" />}
                </div>
            </div>}
        </div>
    }
}

function mapStateToProps(state) {
    return {
        stats: state.stats,
        filter: state.filter
    } 
}

export default connect(mapStateToProps)(TerritoryStats);